import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <UpdatesSection />
        <ContactSection />
        <MediaSection />
        <AboutSection />
        <RankingSection />
        <FaqSection />
        <FeaturesSection />
        <CommentsSection />
        <IndexSection />
        <TopicsSection />
        <AppSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}